import { Box } from "@chakra-ui/react";
import { useSelectIsCaseView } from "../../routes/registries/stores/select/useSelectIsCaseView";
import { useSelectIsGeneMapView } from "../../routes/registries/stores/select/useSelectIsGeneMapView";
import { CasesMapChart } from "./CasesMapChart";
import GeneMap from "./GeneMap";

interface IProps {
  gridRef: any;
}

const RegistryLeaf = ({ gridRef }: IProps) => {
  const isGeneMapView = useSelectIsGeneMapView();
  const isCaseView = useSelectIsCaseView();

  return (
    <Box h="full" w="full">
      {isGeneMapView && <GeneMap gridRef={gridRef}></GeneMap>}
      {isCaseView && <CasesMapChart gridRef={gridRef}></CasesMapChart>}
    </Box>
  );
};

export default RegistryLeaf;
